import { SystemLabel } from './system-label';

export class LowStockSystemLabel extends SystemLabel {
  getSortOrderTitle(): string {
    return 'Low Stock';
  }
}
